import { identity } from "../auth";

export type AppStateUserProfile = {
  id: string | undefined;
  picture: string | undefined;
  roleName: RoleType | undefined;
  roleNameList: RoleType[] | undefined;
  email: string | undefined;
  baseNodeId: number | undefined;
  profileState: ProfileState | undefined;
  providers: string[];
  status: string | undefined;
  language: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  gender: string | undefined;
  dateOfBirth: Date | undefined;
  isLoading: boolean | undefined;
  selectedNodeId: number | undefined;
  endNodeId: number | undefined;
  monitorNodeId: number | undefined;
  notifications: notificationsSettings;
  idetityProviders: identity[];
  isLoadingEdit: boolean | undefined;
  notificationSound?: boolean;
};
export enum ProfileState {
  NeedContactInfo = "needContactInfo",
  NeedOrganizationInfo = "needOrganizationInfo",
  Completed = "completed",
}
export type notificationsSettings = {
  push: boolean;
  sound: boolean;
  vibration: boolean;
};
export enum RoleType {
  OWNER = "Owner",
  ADMIN = "Admin",
  VIEWER = "Viewer",
  DEV = "Dev",
  API_USER = "APIUser",
  CAREGIVER = "Caregiver",
  DISPLAY = "DisplayUser",
}
export type UserProfileResponce = {
  id: string | undefined;
  picture: string | undefined;
  roleName: string | undefined | string[];
  email: string | undefined;
  baseNodeId: number | undefined;
  profileState: ProfileState | undefined;
  providers: string[];
  status: string | undefined;
  language: string | undefined;
  firstName: string | undefined;
  lastName: string | undefined;
  gender: string | undefined;
  dateOfBirth: Date | undefined;
};

export type UserProfileSocket = {
  firstName: string;
  lastName: string;
  nodeId: number;
  profileState: ProfileState;
  status: string;
  userId: string;
};

// export type deviceData = {
//     mobileId: string;
//     serviceToken: string;
//     deviceType: string;
//     metadata: string;
//     debugMode: string;
//     serviceTokenType: string;
// };

// export type subscribeData = deviceData & { nodeIds: string[] };

// export type unsubscribeData = {
//     mobileId: string;
// };
// export type checkData = {
//     mobileId: string;
//     serviceToken: string;
//     serviceTokenType: string;
// };

// export type updateData = subscribeData & { tokenType?: string; token?: string };
// export type notifyLoginLogoutDTO = {
//     email: string;
//     userId: string;
// };
